export default "__VITE_ASSET__sRPTJnxE__"